import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

// Which households the analytics pages count: all, or only SERVER / only LOCAL storage mode.
// Kept while moving between pages so every dashboard shows the same slice.
export type StorageModeFilterValue = '' | 'SERVER' | 'LOCAL';

let current: StorageModeFilterValue = '';
const listeners = new Set<() => void>();

export const useStorageModeFilter = () =>
  useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current
  );

const setStorageMode = (value: StorageModeFilterValue) => {
  current = value;
  listeners.forEach((listener) => listener());
};

const StorageModeFilter = () => {
  const { t } = useTranslation();
  const value = useStorageModeFilter();
  const options: StorageModeFilterValue[] = ['', 'SERVER', 'LOCAL'];

  return (
    <div className='mt-4 flex items-center gap-2 text-sm'>
      <span className='text-muted-foreground'>{t('common.storageMode.label')}</span>
      <div className='inline-flex rounded-md border border-border'>
        {options.map((option) => (
          <button
            key={option || 'all'}
            type='button'
            onClick={() => setStorageMode(option)}
            className={`px-3 py-1 first:rounded-l-md last:rounded-r-md ${
              value === option ? 'bg-primary text-primary-foreground' : 'text-foreground'
            }`}
          >
            {t(`common.storageMode.${option || 'all'}`)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default StorageModeFilter;
